import './code.scss';
const vCode = {
    mounted(el: any) {
        //获取代码片段
        let code = el.querySelector('code.hljs')
        let pre = document.getElementsByTagName('pre')[0]
        let html = code?.innerHTML
        let size = html.split('\n').length


        let code2 = el.querySelector('code.hljs.xml')



        if (code2) {
            // 获取 code 元素内的文本内容  
            let codeContent = code2.innerHTML;

            // 使用正则表达式匹配 x.x.x(官网查看最新版本号)  
            // 注意：这里的正则表达式稍作调整，以确保匹配的准确性  

            // 使用 replace 方法将匹配到的文本替换为带有 span 标签的文本  
            // 并为 span 标签添加样式以改变文本颜色  

            code2.innerHTML = code2.innerHTML
            .replace(/(x\.x\.x\(点击查看最新版本号1\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-java-sdk-core" >x.x.x(官网查看最新版本号)</span>') 
            .replace(/(x\.x\.x\(点击查看最新版本号2\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-projectregistration" >x.x.x(官网查看最新版本号)</span>') 
            .replace(/(x\.x\.x\(点击查看最新版本号3\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-projectbidopening" >x.x.x(官网查看最新版本号)</span>') 
            .replace(/(x\.x\.x\(点击查看最新版本号4\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-projectevaluation" >x.x.x(官网查看最新版本号)</span>')
            .replace(/(x\.x\.x\(点击查看最新版本号5\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-projectcollectionandarchiving" >x.x.x(官网查看最新版本号)</span>') 
            .replace(/(x\.x\.x\(点击查看最新版本号6\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-projectbidevaluation" >x.x.x(官网查看最新版本号)</span>') 
            .replace(/(x\.x\.x\(点击查看最新版本号7\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-seatsync" >x.x.x(官网查看最新版本号)</span>') 

            .replace(/(x\.x\.x\(点击查看最新版本号8\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-placeseatreservationresult" >x.x.x(官网查看最新版本号)</span>') 

            .replace(/(x\.x\.x\(点击查看最新版本号9\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-getsetopendirectory" >x.x.x(官网查看最新版本号)</span>') 

            .replace(/(x\.x\.x\(点击查看最新版本号10\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-projectregistration" >x.x.x(官网查看最新版本号)</span>') 


            
            .replace(/(x\.x\.x\(点击查看最新版本号11\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-placeseatreservationapply" >x.x.x(官网查看最新版本号)</span>') 

            .replace(/(x\.x\.x\(点击查看最新版本号12\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-placeexpertcheckin" >x.x.x(官网查看最新版本号)</span>') 

            .replace(/(x\.x\.x\(点击查看最新版本号13\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-assignexpertphysicalseat" >x.x.x(官网查看最新版本号)</span>') 


            .replace(/(x\.x\.x\(点击查看最新版本号14\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-component-expertlibraryshareextract" >x.x.x(官网查看最新版本号)</span>') 



            .replace(/(x\.x\.x\(点击查看最新版本号15\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-expertlibraryshareextract" >x.x.x(官网查看最新版本号)</span>') 


            .replace(/(x\.x\.x\(点击查看最新版本号16\))/g, '<span class="highlightx" data-url="https://central.sonatype.com/artifact/com.cebpubservice.remotebidevaluation/cebpubservice-remotebidevaluation-java-sdk-getsetopendirectory" >x.x.x(官网查看最新版本号)</span>') 



            




            


            

            

            // let newContent = codeContent.replace(regex, `<span class="highlightx" >$1</span>`);


            // 由于直接设置 textContent 或 innerText 会移除所有 HTML 标签  
            // 我们需要将新的内容设置为 code 元素的 innerHTML  
            // code2.innerHTML = newContent;

            



         

         
            




            // 为所有带有 highlightx 类的 span 元素添加点击事件监听器  
            code2.querySelectorAll('.highlightx').forEach((span1: HTMLElement) => {
                span1.addEventListener('click', function () {
                    // 获取 data-url 属性（这里应该替换为实际的 URL 处理逻辑）  
                    let url = span1.getAttribute('data-url');

                    // 执行点击后的逻辑，例如跳转到 URL  
                    toUrl(url); // 假设 toUrl 是一个已定义的函数  
                });
            });

            // 假设的 toUrl 函数，用于处理点击后的跳转或其他逻辑  
            function toUrl(url: any) {
                // 这里可以是打开新窗口、跳转到当前窗口等逻辑  
                window.open(url, '_blank'); // 示例：在新窗口中打开 URL  
            }


        }





        //插入行数
        let ul = document.createElement('ul')
        for (let i = 1; i <= size; i++) {
            let li = document.createElement('li')
            li.innerText = i + ''
            ul.appendChild(li)
        }

        ul.classList.add('hljs-code-number')

        // el.insertBefore(ul, pre)


    }
}

export default vCode
